// extracted by mini-css-extract-plugin
module.exports = {"codeBox":"codeBox--25dTj","codeBoxSegment":"codeBoxSegment--1ilXT","codeBoxContent":"codeBoxContent--kRVmd","wrap":"wrap--2HUSf","omittedLabel":"omittedLabel--2wNgd"};